import React from 'react';

import * as S from '../tenant-satisfaction-survey/styles';

// const listQuestions = [
//   {
//     id: 1,
//     title: 'Como foi o seu atendimento na imobiliária?',
//     radios: [
//       {value: 'Nada satisfeito', label: 'Nada satisfeito'},
//       {value: 'Pouco satisfeito', label: 'Pouco satisfeito'},
//       {value: 'Moderadamente satisfeito', label: 'Moderadamente satisfeito'},
//       {value: 'Muito satisfeito', label: 'Muito satisfeito'},
//       {value: 'Extremamente satisfeito', label: 'Extremamente satisfeito'}
//     ],
//     valueRadio: 'question1Radio'
//   },

//   {
//     id: 2,
//     title: 'Como foi a agilidade do serviço prestado pela CredPago?',
//     radios: [
//       {value: 'Nada ágil', label: 'Nada ágil'},
//       {value: 'Pouco ágil', label: 'Pouco ágil'},
//       {value: 'Muito ágil', label: 'Muito ágil'},
//       {value: 'Extremamente ágil', label: 'Extremamente ágil'}
//     ],
//     valueRadio: 'question2Radio'
//   },

//   {
//     id: 3,
//     title: 'Qual a chance de indicar a CredPago para um amigo/ familiar?',
//     radios: [
//       {value: 'Não indicaria', label: 'Não indicaria'},
//       {value: 'Talvez indicaria', label: 'Talvez indicaria'},
//       {value: 'Com certeza indicaria', label: 'Com certeza indicaria'}
//     ],
//     valueRadio: 'question3Radio'
//   }
// ]

const listQuestions = {
  questionOne: {
    options: [
      {
        id: 1,
        img: <S.ImgNote1 />,
        alt: 'Escala 1',
      },

      {
        id: 2,
        img: <S.ImgNote2 />,
        alt: 'Escala 2',
      },

      {
        id: 3,
        img: <S.ImgNote3 />,
        alt: 'Escala 3',
      },

      {
        id: 4,
        img: <S.ImgNote4 />,
        alt: 'Escala 4',
      },

      {
        id: 5,
        img: <S.ImgNote5 />,
        alt: 'Escala 5',
      },

      {
        id: 6,
        img: <S.ImgNote6 />,
        alt: 'Escala 6',
      },

      {
        id: 7,
        img: <S.ImgNote7 />,
        alt: 'Escala 7',
      },

      {
        id: 8,
        img: <S.ImgNote8 />,
        alt: 'Escala 8',
      },

      {
        id: 9,
        img: <S.ImgNote9 />,
        alt: 'Escala 9',
      },

      {
        id: 10,
        img: <S.ImgNote10 />,
        alt: 'Escala 10',
      },
    ],
  },

  equalQuestion: [
    {
      id: 2,
      title: 'Como você avalia o atendimento da CredPago?',
      radios: [
        { value: 'Péssimo', label: 'Péssimo' },
        { value: 'Bom', label: 'Bom' },
        { value: 'Ótimo', label: 'Ótimo' },
      ],
      valueRadio: 'question2Radio',
      valueText: 'question2Text',
    },
    {
      id: 3,
      title: 'Qual probabilidade de utilizar a CredPago em novos contratos?',
      radios: [
        { value: 'Pouco Provável', label: 'Pouco Provável' },
        { value: 'Provável', label: 'Provável' },
        { value: 'Muito Provável', label: 'Muito Provável' },
      ],
      valueRadio: 'question3Radio',
      valueText: 'question3Text',
    },
  ],
};

export default listQuestions;
